import React from 'react';
import { Button, Well, Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Link from '../../components/Link';
import s from './Home.css';
import { pobierzListGmin } from '../../actions/gminy';
import ihubPhoto from './ihub2_photo.png';
import { headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import Euslugi from '../euslugi/Euslugi'


const mapState = (state) => ({
  district: state.district.district,
  user: state.user,
  bounceCounter: state.style.bounceCounter,
  printModalStatus: state.printSettings.printModalStatus,
  fontSize: state.runtime.fontSize,
  messages: state.intl.messages,
  powiaty: state.powiaty,
  arePowiatyFetched: state.powiaty.arePowiatyFetched,
  gminy: state.gminy,
  areGminyFetched: state.gminy.areGminyFetched,
  districts: state.district.districts,
});
const mapDispatch = {
  pobierzListGmin,
};
const buttonStyle = {
  marginTop: '30px',
  marginBottom: '20px',
  height: '50px',
  width: '100%',
  borderRadius: '0',
  boxShadow: '0px 3px 14px -2px black',
  outline: 'none',
  // padding: '6px 18px 6px 18px',
};

class MenuRozwijane extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      colors: 'normal',
    };
  }

  componentDidMount() {
    this.updateTheme();
  }

  updateTheme() {
    const theme = getThemeFromLocalStorage();
    if (this.state.colors !== theme) {
      if (theme !== 'normal') {
        buttonStyle['color'] = headerStyle[theme].color;
        buttonStyle['backgroundColor'] = headerStyle[theme].backgroundColor;
      } else {
        buttonStyle['color'] = '';
        buttonStyle['backgroundColor'] = '';
      }
      this.setState({ colors: theme });
    }
  }

  render() {
    return (
      <div>
        <Button
          style={buttonStyle}
          bsSize="large"
          bsStyle="primary"
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <span className="glyphicon glyphicon-arrow-right" />
          <text style={{ margin: '0 20px 0 20px' }}>
            Lista zarejestrowanych gmin
          </text>
          <span className="glyphicon glyphicon-arrow-left" />
        </Button>
        <Collapse in={this.state.open}>
          <div>
            <Well style={{ background: buttonStyle.backgroundColor }}>
              {this.props.districts && Object.keys(this.props.districts).sort().map(item => (
                <div key={item}>
                  <Link
                    to={`/urzad/${this.props.districts[item].prefix}`}
                  >
                    {this.props.districts[item].name}
                  </Link>
                </div>
              ))}
            </Well>
          </div>
        </Collapse>
      </div>
    );
  }
}

class MainContent extends React.Component {
  renderMainPage() {
    return(
      <div style={{ minHeight: "650px", marginTop: "-80px" }}>
        <div className={s.container}>
          <div className={s.ihubPhoto}>
            <img src={ihubPhoto} alt={ihubPhoto} />
            <a href='https://pl.freepik.com/darmowe-zdjecie/rece-z-laptopem-i-mapie-swiata-wirtualnego_979060.htm#page=1&query=komputer&position=44'>pl.freepik.com</a>
          </div>
          {/* <MenuRozwijane districts={this.props.districts}/> */}
          <div className={s.offerContainer}>
            <h3>Oferta</h3>

            <div className={s.offerItem}>
              <h4>Zasięg Map</h4>
              <p>
                Zapraszamy na PORTAL WODGiK, w&nbsp;którym przedstawiamy zasięg przestrzenny 
                wszystkich materiałów zgromadzonych w&nbsp;zasobie WODGiK
              </p>
            </div>
            <div className={s.offerItem}>
              <h4>
                Standardowe<br/>
                Opracowania Topograficzne
              </h4>
              <p>
                Opracowania topograficzne w&nbsp;różnych skalach wykonane po roku 2011 
                w&nbsp;standardzie zgodnym z&nbsp;Rozporządzeniem
                Dz.&nbsp;U.&nbsp;Nr&nbsp;279 Poz.&nbsp;1642 z&nbsp;2011 r.
              </p>
            </div>
            <div className={s.offerItem}>
              <h4>
                Niestandardowe<br/>
                Opracowania Topograficzne
              </h4>
              <p>
                <a href="http://172.26.2.12/psip/bdot10k?baseMap=none&checkedLayers=6197%2C6198%2C6199%2C6200%2C6201%2C6202%2C6203%2C6204%2C6205%2C6206%2C6207%2C6208%2C6209%2C6210%2C6211%2C6212%2C6213%2C6214%2C6215%2C6216%2C6217%2C6218%2C6219%2C6220%2C6221%2C6222%2C6223%2C6224%2C6225%2C6226%2C6227%2C6228%2C6229%2C6230%2C6231%2C6232%2C6233%2C6234%2C6235%2C6236%2C6237%2C6238%2C6239%2C6240%2C6241%2C6242%2C6243%2C6244%2C6245%2C6246%2C6247%2C6248%2C6249%2C6250%2C6251%2C6252%2C6253%2C6254%2C6255%2C6256%2C6257%2C6258%2C6259%2C6260%2C6261%2C6262%2C6263%2C6264%2C6265%2C6266%2C6267%2C6268%2C6269%2C6270%2C6271%2C6272%2C6273%2C6274%2C6275%2C6276%2C6277%2C6278%2C6279%2C6280%2C6281%2C6282%2C6283%2C6284%2C6285%2C6286%2C6287%2C6288%2C6289%2C6290%2C6291%2C6292%2C6293%2C6294%2C6295%2C6296%2C6297%2C6298&composition=53&lat=49.59691512969532&lng=21.574401855468754&zoom=10">
                  Opracowania topograficzne w&nbsp;różnych skalach wykonane do roku 2011 
                </a>
              </p>
            </div>
            <div className={s.offerItem}>
              <h4>
              Ortofotomapa
              </h4>
              <p>
              Ortofotomapy cyfrowe wykonane ze zdjęć lotniczych 
              z&nbsp;różnych lat; Ortofotomapy stanowią Zasób Centralny 
              zatem szerszą ofertę znajdą Państwo na stronie 
              Centralnego Ośrodka Dokumentacji Geodezyjnej i&nbsp;Kartograficznej
              </p>
            </div>
            <div className={s.offerItem}>
                <h4>
                  Bdot 10K
                </h4>
              <p>
                <a href="http://172.26.2.12/psip/bdot10k?baseMap=none&checkedLayers=6197%2C6198%2C6199%2C6200%2C6201%2C6202%2C6203%2C6204%2C6205%2C6206%2C6207%2C6208%2C6209%2C6210%2C6211%2C6212%2C6213%2C6214%2C6215%2C6216%2C6217%2C6218%2C6219%2C6220%2C6221%2C6222%2C6223%2C6224%2C6225%2C6226%2C6227%2C6228%2C6229%2C6230%2C6231%2C6232%2C6233%2C6234%2C6235%2C6236%2C6237%2C6238%2C6239%2C6240%2C6241%2C6242%2C6243%2C6244%2C6245%2C6246%2C6247%2C6248%2C6249%2C6250%2C6251%2C6252%2C6253%2C6254%2C6255%2C6256%2C6257%2C6258%2C6259%2C6260%2C6261%2C6262%2C6263%2C6264%2C6265%2C6266%2C6267%2C6268%2C6269%2C6270%2C6271%2C6272%2C6273%2C6274%2C6275%2C6276%2C6277%2C6278%2C6279%2C6280%2C6281%2C6282%2C6283%2C6284%2C6285%2C6286%2C6287%2C6288%2C6289%2C6290%2C6291%2C6292%2C6293%2C6294%2C6295%2C6296%2C6297%2C6298&composition=53&lat=49.59691512969532&lng=21.574401855468754&zoom=10">
                  Baza danych obiektów topograficznych o&nbsp;dokładności odpowiadającej 
                  mapom topograficznym w&nbsp;skali 1:10&nbsp;000, wykonana w&nbsp;standardzie 
                  zgodnym z&nbsp;Rozporządzeniem Dz.&nbsp;U.&nbsp;Nr&nbsp;279 Poz.&nbsp;1642 z&nbsp;2011&nbsp;r. 
                  Baza dostępna jest w&nbsp;formatach xml/mdb/shp
                </a>
              </p>
            </div>
            <div className={s.offerItem}>
              <h4>
              Opracowania<br/>
              tematyczne i Specjalne
              </h4>
              <p>
              Opracowania tematyczne i&nbsp;specjalne o&nbsp;znaczeniu wojewódzkim, m.in.: 
              mapa sozologiczna, mapa hydrograficzna, baza gleb, baza numerów dróg, 
              mapa produktów tradycyjnych
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Euslugi />
    );
  }
}

const Home = connect(mapState, mapDispatch)(MainContent);

export default withStyles(s)(Home);



// WEBPACK FOOTER //
// src/routes/home/Home.js